import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { withRouter } from 'next/router';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as types from '../../../../actions/actionTypes';
import { getTrends } from '../../../../actions/listing';
import Messages, { MessagesTypes } from '../../../utility/Messages';
import TextField from '../../../utility/TextField';
import track from '../../../../lib/track';
import { maxValue } from '../../../../lib/helpers';
import validations, { composeValidators } from '../../../../lib/validation';
import { buttonStyles } from '../../../../styles/base';

export interface Props {
  classes: any;
  dispatch: any;
  handleStateChange: Function;
  messages: MessagesTypes;
  noBedrooms: any;
  router: any;
  token: string;
  zip: any;
}

const styles = {
  form: {
    margin: '0 auto',
  },
};

export class TrendsForm extends React.Component<Props, {}> {
  handleSubmit = (values: any) => {
    if (!this.props.token) {
      this.props.dispatch({
        postAuthPath: this.props.router.pathname,
        type: types.OpenSignupDialog,
      });
    } else {
      track.toolUsed('Trend Spotter', values);
      this.props.handleStateChange(values);
      this.props.dispatch(getTrends(values.zip, values.noBedrooms));
    }
  };

  render() {
    const { classes, messages, zip, noBedrooms } = this.props;
    return (
      <Form
        onSubmit={this.handleSubmit}
        initialValues={{ zip, noBedrooms }}
        render={({ handleSubmit, values }) => (
          <form style={styles.form}>
            <Messages messages={messages} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                className="tool-form col-xs-12 row center-xs between-sm"
                style={{ margin: '0 auto', width: 430 }}
              >
                <Field
                  name="zip"
                  type="text"
                  component={TextField}
                  label="Zip Code"
                  placeholder="#"
                  autoComplete="off"
                  validate={composeValidators(
                    validations.zipCode,
                    validations.required,
                  )}
                  style={{ marginTop: 10, width: 200 }}
                />

                <Field
                  name="noBedrooms"
                  type="text"
                  component={TextField}
                  label="Number of Bedrooms"
                  placeholder="#"
                  value={2}
                  autoComplete="off"
                  validate={composeValidators(
                    validations.number,
                    validations.required,
                  )}
                  style={{ marginTop: 10, width: 200 }}
                  parse={maxValue(10)}
                />
              </div>
              <br />
              <br />
              <Button
                disabled={
                  values.noBedrooms && values.zip && values.zip.length === 5
                    ? false
                    : true
                }
                variant="contained"
                className={`${classes.buttonMediumGreen}`}
                onClick={handleSubmit}
                type="submit"
                style={{ alignSelf: 'center' }}
              >
                SUBMIT
              </Button>
            </div>
          </form>
        )}
      />
    );
  }
}

const mapStateToProps = (state: any) => ({
  messages: state.messages,
  token: state.auth.token,
});

export default connect(mapStateToProps)(
  withStyles(buttonStyles)(withRouter(TrendsForm)),
);
